import type { DocumentLakou } from './types.js';

export interface FiltreDocuments {
  personneId?: string | undefined;
  bienId?: string | undefined;
}

const recentDabord = (a: DocumentLakou, b: DocumentLakou): number => Date.parse(b.receivedAt) - Date.parse(a.receivedAt);
const lieA = (d: DocumentLakou, type: 'person' | 'asset', id: string): boolean =>
  d.links.some((l) => l.targetType === type && l.targetId === id);

/** Filtre par personne et/ou par bien (les deux se cumulent), du plus récent au plus ancien. */
export function filtrerDocuments(documents: readonly DocumentLakou[], filtre: FiltreDocuments): DocumentLakou[] {
  return documents
    .filter(
      (d) =>
        (filtre.personneId === undefined || lieA(d, 'person', filtre.personneId)) &&
        (filtre.bienId === undefined || lieA(d, 'asset', filtre.bienId)),
    )
    .sort(recentDabord);
}

export function optionsFiltres(documents: readonly DocumentLakou[]): { personnes: string[]; biens: string[] } {
  const ids = (type: 'person' | 'asset'): string[] =>
    [...new Set(documents.flatMap((d) => d.links.filter((l) => l.targetType === type).map((l) => l.targetId)))].sort();
  return { personnes: ids('person'), biens: ids('asset') };
}
